module.exports = __webpack_public_path__ + "img/prioritas_sameday_dfod_dg_k.5f87a496.png";